import React from 'react';
import Carousel from '../carousel/carousel';
import { NavLink } from "react-router-dom";
import Mantra_3_A1_Canvas from './Mantra_3_A1_Canvas';
import { userDetailStore } from '../../config/store';
import $ from 'jquery';
import { Html2CanvasFunction } from '../../utils/NewHelper';
import { postData, postDataBlob, dataURLToBlob, translation, onImageFileUploaded } from '../../utils/helper';
import { showCongratulations } from "../../utils/misc";
import Loader from "../loader/loader";

class Mantra_3_A1_Edit extends React.Component {
    constructor() {
        super();
        this.state = {
            defaultName: userDetailStore.getState().userDetail && userDetailStore.getState().userDetail['user_name_display'],
            yourFriendName: "",
            reasonOn1: "",
            reasonOn2: "",
            reasonOn3: "",
            isLoading: false
        }
    }

    onChageHandler = (e) => {
        const { value, name } = e.target;
        if ((value).length <= 30) {
            this.setState({
                [name]: value
            })
        }

    }

    postData = async () => {
        // e.preventDefault();
        this.setState({
            isLoading: true
        })

        if (this.state.yourFriendName && this.state.reasonOn1) {

            //canvas this means canvas is all set, read the name and festival and generate canvas now
            $(".preloader_mantra").show();
            var ref = this;
            let reqdata = {
                type: ref.props.type,
                module_name: ref.props.module_name
            }
            let resData = await Html2CanvasFunction(reqdata)
            resData.addEventListener("load", function (data) {
                data = resData.response;
                data = JSON.parse(data);
                var imageUrl = data.data.cardimage;
                var id = data.data.id;
                ref.setState({
                    "shareData": imageUrl,
                    "id": id, "image": null,
                    isLoading: false
                }, () => {
                    showCongratulations(ref.props.module_name)
                    onImageFileUploaded({
                        image: imageUrl,
                        module: ref.props.module_name,
                        postid: id
                    });
                });

                ref.props.onCanVase(imageUrl, id)
                // ref.processShare(data, params, ref);

            });
        } else {
            alert('All Fields are required.');
            this.setState({
                isLoading: false
            })
        }
    }

    render() {

        const { defaultName, yourFriendName, reasonOn1, reasonOn2, reasonOn3, isLoading } = this.state;

        if (isLoading) {
            return (
                <Loader />
            )
        }

        return (
            <>
                {/* <Carousel /> */}
                <div className="m3_a1_container container">
                    <div className="m3_p_img">
                        <div className="m3_p_img_prev">
                            <span>Preview</span>
                        </div>
                        <section className="m3_prev_section mantra3_canvas">
                            <div className="mantra3_a1 mantra3_a1_back">
                                <h3 className="mantra3_a1_name">Dear,</h3>
                                <h3 className="mantra3_a1_name2">{yourFriendName}</h3>
                            </div>
                            <div className="m3_em_para">
                                <p className="m3_canvas_para">Here are three things about you that make me laugh!
                    <span className="m3_em_wrp">
                                        <img src="/assets/img/em1.png" />
                                        <img src="/assets/img/em2.png" />
                                        <img src="/assets/img/em3.png" />
                                    </span>
                                </p>

                            </div>
                            <ol className="mantra_ol" type="1">
                                <li><span>1.</span>{reasonOn1}</li>
                                <li><span>2.</span>{reasonOn2}</li>
                                <li><span>3.</span>{reasonOn3}</li>
                            </ol>
                            <p className="m3_canvas_para2">Wishing you Best of luck for the exam!</p>
                        </section>

                        {/* <img src="/assets/img/mantra3_form.png" className="m3a1_img" /> */}
                    </div>
                    <section className="m3_form">
                        <div className="m3_form_group active">
                            <label className="m3_label">Your friend's name *</label>
                            <input className="m3_input active" ref={(f_name) => { this.f_name = f_name }} type="text" name="yourFriendName" value={yourFriendName} onChange={(e) => { (e.target.value).length <= 15 && this.setState({ yourFriendName: e.target.value }) }} />
                        </div>
                        <div className="m3_form_group">
                            <label className="m3_label">Reason 1</label>
                            <input className="m3_input" type="text" name="reasonOn1" value={reasonOn1} onChange={(e) => this.onChageHandler(e)} />
                        </div>
                        <div className="m3_form_group">
                            <label className="m3_label">Reason 2</label>
                            <input className="m3_input" type="text" name="reasonOn2" value={reasonOn2} onChange={(e) => this.onChageHandler(e)} />
                        </div>
                        <div className="m3_form_group">
                            <label className="m3_label">Reason 3</label>
                            <input className="m3_input" type="text" name="reasonOn3" value={reasonOn3} onChange={(e) => this.onChageHandler(e)} />
                        </div>
                        <div className="m3_form_group">
                            <label className="m3_label">Your name *</label>
                            <input className="m3_input" defaultValue={defaultName} ref={(name) => { this.name = name }} type="text" />
                        </div>
                        <button className="btn_f" onClick={() => this.postData()}>Done & Share</button>
                    </section>
                </div>
                {
                    yourFriendName && reasonOn1 &&
                    <Mantra_3_A1_Canvas name={yourFriendName} {...this.state} module_name={this.props.module_name} />
                }
            </>
        )
    }
}

export default Mantra_3_A1_Edit;